module.exports = __webpack_public_path__ + "media/images/front/university_hospitals/university_twmu-e4085f38c4c39b2f92631ffe107a9fe0.png";